import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { DashboardsModule } from './dashboards/dashboards.module';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, LoadingComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'oxy-backoffice-front';

  constructor(private router: Router,
    private oidc: OidcSecurityService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
  if (!isPlatformBrowser(this.platformId)) return;

  const href = window.location.href;
  const isCallback =
    href.includes('/auth-callback') &&
    (href.includes('code=') || href.includes('state='));

  if (isCallback) {
    return;
  }

  this.oidc.checkAuth().pipe(
    catchError((e) => {
      const msg = String(e || '');
      if (msg.includes('no code in url') || msg.includes('could not find matching config for state')) {
        return of(null);
      }
      console.error('checkAuth (boot) error:', e);
      return of(null);
    })
  ).subscribe();
}

  showLayout(): boolean {
    const hiddenRoutes = ['/login', '/auth-callback', '/logout-callback'];
    return !hiddenRoutes.includes(this.router.url);
  }
  
}
